<template>
  <div
    v-if="issueKey"
    class="jira-link"
  >
    <a
      :href="href"
      class="btn btn-xs jira"
      target="_blank"
    >
      <i class="fab fa-jira" />
      {{ issueKey }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    issueKey: {
      type: [String, null],
      required: true,
    },
    href: {
      type: [String, null],
      required:true,
    }
  }
}
</script>

<style scoped>
.jira-link {
  display: flex;
  justify-content: center;
}
.jira {
  background-color: #0052CC;
  color: white;
  margin: 0;
  white-space: nowrap;
  border-radius: 5px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
  font-size: 10px;
  padding: 5px 10px;
  letter-spacing: 1px;
}
</style>
